import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "cell-container"
};
const _hoisted_2 = {
  class: "time"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "message-content"
};
const _hoisted_5 = {
  class: "role-info-row"
};
const _hoisted_6 = {
  class: "time"
};
const _hoisted_7 = {
  class: "nickname"
};
const _hoisted_8 = {
  class: "content"
};
const _hoisted_9 = {
  class: "operator-bar"
};
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = {
  class: "message-content"
};
const _hoisted_13 = {
  class: "role-info-row"
};
const _hoisted_14 = {
  class: "nickname"
};
const _hoisted_15 = {
  class: "time"
};
const _hoisted_16 = {
  class: "content"
};
const _hoisted_17 = {
  class: "operator-bar"
};
const _hoisted_18 = ["src", "alt"];
const _hoisted_19 = {
  class: "message-content"
};
const _hoisted_20 = {
  class: "role-info-row"
};
const _hoisted_21 = {
  class: "nickname"
};
const _hoisted_22 = {
  class: "time"
};
const _hoisted_23 = {
  class: "content"
};
const _hoisted_24 = ["src", "alt"];
const _hoisted_25 = {
  class: "message-content"
};
const _hoisted_26 = {
  class: "role-info-row"
};
const _hoisted_27 = {
  class: "nickname"
};
const _hoisted_28 = {
  class: "time"
};
const _hoisted_29 = {
  class: "content"
};
import { computed } from 'vue';
import { placeholderImage } from '@/tools/utils';
import { CopyDocument } from '@element-plus/icons-vue';
import dayjs, { Dayjs } from "dayjs";
import { ElMessage } from "element-plus";
export default {
  __name: 'ChatCell',
  props: {
    isSelf: {
      type: Boolean,
      required: true,
      default: false
    },
    message: {
      type: Object,
      required: true
    },
    roleInfo: {
      type: [Object, null],
      required: true,
      default: () => {}
    },
    now: {
      type: Dayjs,
      required: true
    }
  },

  setup(__props) {
    // pre-declaration
    const props = __props; // computed

    const chatType = computed(() => {
      if (!props.message || !props.message.type) return '';

      switch (props.message.type) {
        case 'event':
          return 'normal-event';

        case 'rolesUpdate':
          return 'normal-event';

        case 'chat':
          return 'normal-message';

        case 'dice':
          return 'dice';

        case 'narration':
          return 'narration';

        default:
          return 'normal-message';
      }
    }); // functions

    const formatTime = timestamp => {
      if (!props.now) return '未知时间';
      const time = dayjs(timestamp).tz('Asia/Shanghai');
      const diffMinutes = props.now.diff(time, 'minute');
      const diffSeconds = props.now.diff(time, 'second');

      if (diffMinutes < 10) {
        if (diffSeconds <= 10) {
          return '刚刚';
        } else if (diffMinutes < 1) {
          return '1分钟内'; // return `${diffSeconds}秒前`
        }

        return `${diffMinutes}分钟前`;
      }

      const isSameDay = props.now.isSame(time, 'day');

      if (!isSameDay) {
        return time.format('MM-DD HH:mm:ss');
      }

      return time.format('HH:mm:ss');
    };

    const copyIt = async () => {
      try {
        await navigator.clipboard.writeText(props.message?.content ?? '');
        ElMessage.success({
          message: '内容已复制',
          duration: 1500
        });
      } catch (err) {
        ElMessage.error({
          message: '部分浏览器无法应用自动复制',
          duration: 1500
        });
      }
    };

    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [chatType.value.endsWith('event') ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["base-row", chatType.value])
      }, [_createElementVNode("div", _hoisted_2, _toDisplayString(formatTime(__props.message.timestamp)), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.message.content), 1)], 2)) : chatType.value.endsWith('message') && __props.isSelf ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["base-row self", chatType.value])
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(formatTime(__props.message.timestamp)), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(__props.roleInfo?.nickname), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(__props.message.content), 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
        onClick: copyIt
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 14
        }, {
          default: _withCtx(() => [_createVNode(_unref(CopyDocument))]),
          _: 1
        })]),
        _: 1
      })])]), _createElementVNode("img", {
        src: __props.roleInfo?.avatar ?? _unref(placeholderImage),
        alt: __props.roleInfo?.nickname,
        class: "avatar"
      }, null, 8, _hoisted_10)], 2)) : chatType.value.endsWith('message') ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["base-row", chatType.value])
      }, [_createElementVNode("img", {
        src: __props.roleInfo?.avatar ?? _unref(placeholderImage),
        alt: __props.roleInfo?.nickname,
        class: "avatar"
      }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(__props.roleInfo?.nickname), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(formatTime(__props.message.timestamp)), 1)]), _createElementVNode("div", _hoisted_16, _toDisplayString(__props.message.content), 1), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
        onClick: copyIt
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 14
        }, {
          default: _withCtx(() => [_createVNode(_unref(CopyDocument))]),
          _: 1
        })]),
        _: 1
      })])])], 2)) : chatType.value === 'dice' ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: _normalizeClass(["base-row", chatType.value])
      }, [_createElementVNode("img", {
        src: __props.roleInfo?.avatar ?? _unref(placeholderImage),
        alt: __props.roleInfo?.nickname,
        class: "avatar"
      }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(__props.roleInfo?.nickname), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "dice-tag"
      }, " 雾海舟子 ", -1)), _createElementVNode("div", _hoisted_22, _toDisplayString(formatTime(__props.message.timestamp)), 1)]), _createElementVNode("div", _hoisted_23, "  " + _toDisplayString(__props.message?.description), 1)])], 2)) : chatType.value === 'narration' ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: _normalizeClass(["base-row", chatType.value])
      }, [_createElementVNode("img", {
        src: __props.roleInfo?.avatar ?? _unref(placeholderImage),
        alt: __props.roleInfo?.nickname,
        class: "avatar"
      }, null, 8, _hoisted_24), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(__props.roleInfo?.nickname), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "dice-tag"
      }, " 雾海舟子 ", -1)), _createElementVNode("div", _hoisted_28, _toDisplayString(formatTime(__props.message.timestamp)), 1)]), _createElementVNode("div", _hoisted_29, "  " + _toDisplayString(__props.message?.content), 1)])], 2)) : _createCommentVNode("", true)]);
    };
  }

};